import React from 'react';
import NavBar from '../navbar/NavBar';
import Page from '../pageHeaderConent/Page';

const HomePage = () => {
  return (
    <div>
      <NavBar />
      <Page />
    </div>
  );
};

export default HomePage;
